<template>
  <div class="app-wrapper" :class="classObj" >
    <sidebar class="sidebar-container" id="sidebars"></sidebar>
    <div class="main-container" id="mains">
      <navbar id="navbars"></navbar>
      <app-main ref="appsmain"></app-main>
    </div>

    <div class="yd-mask" style="z-index: 99999;left: 180px;" v-if="ydMask1">
      <div class="yd-tip-box" style="left: 20px;top: 75%;">
        <div class="yd-sjx-l" style="left: -20px;top: 120px;"></div>
        <div class="yd-title">第一步：系统设置</div>
        <div class="yd-p">请在左侧的菜单中找到“系统设置”（可上下滚动），首先进行本机构登录的LOGO、应聘端访问域名等配置</div>
        <div class="yd-btn-box">
          <div class="yd-btn yd-btn-1" @click="clickYdBtn(1)">立即设置</div>
          <div class="yd-btn yd-btn-2" @click="clickYdBtn(2)">查看下一步</div>
          <div class="yd-btn yd-btn-3" @click="clickYdBtn(3)">关闭</div>
        </div>
      </div>
    </div>
    <div id="yindaos"></div>
    <!--div class="yd-control-box"  id="yindaos"  @mousedown="down" @touchstart="down" @mousemove="move" @touchmove="move" @mouseup="end" @touchend="end" v-if="getMenus('result')">
      <div class="yd-text">开启 / 关闭引导</div>
      <el-switch
              @change="handleStatusChange()"
              :active-value="1"
              :inactive-value="0"
              v-model="isguide"
              active-color='#f85200'
              >
            </el-switch>
    </div-->
  </div>
</template>

<script>


import Cookies from 'js-cookie'
import { Navbar, Sidebar, AppMain } from './components'
import ResizeMixin from './mixin/ResizeHandler'
import { mapGetters } from "vuex";
import { isMenus } from "@/utils/auth";
import { listcateall, passwordExpired } from '@/api/login'
export default {
  name: 'layout',
  components: {
    Navbar,
    Sidebar,
    AppMain
  },
  data() {
      return {
        ydMask1:'',
        ydMask2:'',
        value1: true,
        isguide:1,
        flags: false,
        position: { x: 0, y: 0 },
        nx: '', ny: '', dx: '', dy: '', xPum: '', yPum: '',
      }
  },
  created() {
    if(Cookies.get("GuideStatus")==undefined||Cookies.get("GuideStatus")==1){
      this.$store.dispatch("ToggleGuide");
    }else{
      this.$store.dispatch("CloseGuide");
    }
    this.init();
    listcateall().then(res => {
            //获取所有参数保存本地缓存
            window.localStorage.setItem('VALUECODE', JSON.stringify(res.data));
            })

  },
  methods: {
    init() {
      this.isguide=this.guide;
      if(!this.getMenus('result')){
        this.$store.dispatch("CloseGuide");
      }
    },
    getMenus(m) {
      return isMenus(m, this.menus);
    },
    handleStatusChange() {
      if(this.guide==1){
      this.$store.dispatch("CloseGuide");
      }else{
      this.$store.dispatch("ToggleGuide");
      }
      this.init();
      this.currentPath();

    },
     clickYdBtn(num){
       if(num == 1){
         this.ydMask1 = false
         this.$router.push('/seting/seting');
       }
       if(num == 2){
         this.ydMask1 = false
         this.$router.push('/appset/appset');
       }
       if(num == 3){
         this.ydMask1 = false
       }
     },
     currentPath(){
       // 判断当前路径是否为首页,如果是首页则显示引导,不作判定的话则在其他页面收到刷新页面之后,依然会显示Layout页面的这两个引导，容易造成混乱
        if(this.guide==1&&this.$route.path == '/home'){
          this.ydMask1 = true
          this.ydMask2 = false
        }else{
          this.ydMask1 = false
          this.ydMask2 = false
        }
     },
     // 实现移动端拖拽
      down(){
        this.flags = true;
        var touch;
        if(event.touches){
        touch = event.touches[0];
        }else {
        touch = event;
        }
        this.position.x = touch.clientX;
        this.position.y = touch.clientY;
        this.dx = yindaos.offsetLeft;
        this.dy = yindaos.offsetTop;
      },
      move(){
        if(this.flags){
        var touch ;
        if(event.touches){
        touch = event.touches[0];
        }else {
        touch = event;
        }
        this.nx = touch.clientX - this.position.x;
        this.ny = touch.clientY - this.position.y;
        this.xPum = this.dx+this.nx;
        this.yPum = this.dy+this.ny;
        yindaos.style.left = this.xPum+"px";
        yindaos.style.top = this.yPum +"px";
        //阻止页面的滑动默认事件
        document.addEventListener("touchmove",function(){ // 1.2 如果碰到滑动问题，请注意是否获取到 touchmove
        event.preventDefault();//jq 阻止冒泡事件
        // event.stopPropagation(); // 如果没有引入jq 就用 stopPropagation()
        },false);
        }
      },
      //鼠标释放时候的函数
      end(){
        this.flags = false;
      }
  },
  mounted() {
    this.currentPath()
  },
  mixins: [ResizeMixin],
  computed: {
    ...mapGetters(["menus", "guide"]),
    sidebar() {
      return this.$store.state.app.sidebar
    },
    device() {
      return this.$store.state.app.device
    },
    classObj() {
      return {
        hideSidebar: !this.sidebar.opened,
        withoutAnimation: this.sidebar.withoutAnimation,
        mobile: this.device === 'mobile'
      }
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  @import "src/styles/mixin.scss";
  .app-wrapper {
    @include clearfix;
    position: relative;
    height: 100%;
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/views/layout/Layout.vue